import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LincWerksShell,
  founderOverviewConfig,
  lincForgeWorkflowConfig,
} from "../features/lincwerksDashboard";
import "./LincWerksRedesignPreviewPage.css";

const cloneConfig = (config) => JSON.parse(JSON.stringify(config));

const openPartner = () => {
  const launcher = document.querySelector(".global-partner-launch");
  if (launcher && !launcher.classList.contains("open")) launcher.click();
};

export default function LincWerksRedesignPreviewPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("founder");
  const [config, setConfig] = useState(() => cloneConfig(founderOverviewConfig));
  const [notice, setNotice] = useState("LincWerks home uses sample operating cards until live feeds are wired. Open FocusLinc for live queues.");

  const selectMode = (nextMode) => {
    setMode(nextMode);
    setConfig(cloneConfig(nextMode === "forge" ? lincForgeWorkflowConfig : founderOverviewConfig));
    setNotice(nextMode === "forge" ? "ForgeLinc stage deck: Idea through Orders." : "Founder operating view restored.");
  };

  const updateWorkspace = ({ workspaceId, sectionId, index, value }) => {
    setConfig((current) => ({
      ...current,
      workspaces: current.workspaces.map((workspace) => workspace.id !== workspaceId ? workspace : ({
        ...workspace,
        sections: workspace.sections.map((section) => section.id !== sectionId ? section : ({
          ...section,
          items: section.items.map((item, itemIndex) => itemIndex === index ? value : item),
        })),
      })),
    }));
    setNotice("Preview field updated locally. Backend persistence remains intentionally disconnected.");
  };

  const handleAction = (action, workspace) => {
    if (action === "approve") {
      navigate("/commandlinc/approvals");
      return;
    }
    if (action === "contribute") {
      setNotice(`Contribution controls for ${workspace.title} will use the existing host mutation layer after review.`);
      return;
    }
    if (mode === "founder" && workspace.id === "founder-lincforge") {
      selectMode("forge");
      return;
    }
    const routes = {
      "founder-focus": "/focus/queues",
      "founder-build": "/commandlinc/buildlinc",
      "founder-partners": "/businesses",
    };
    navigate(routes[workspace.id] || "/linkforge");
  };

  const brandMark = (
    <button
      type="button"
      className="lw-preview-brand"
      onClick={() => selectMode("founder")}
      aria-label="Return to Founder Overview"
      title="Founder Overview"
    >
      <img src="/LincWerks2026Logo.png" alt="" />
      <span>LincWerks</span>
    </button>
  );

  return (
    <>
      <LincWerksShell
        config={config}
        role="manager"
        brandMark={brandMark}
        avatarRegistry={{ departmentHeads: [] }}
        onWorkspaceUpdate={updateWorkspace}
        onWorkspaceAction={handleAction}
        onAddWorkspace={() => setNotice("Add Workspace is enabled for managers; persistence is held for the product-contract review.")}
        onOpenAssistant={openPartner}
      />
      <div className="lw-preview-notice" role="status" aria-live="polite">
        <span>{notice}</span>
        {mode === "forge" ? <button type="button" onClick={() => selectMode("founder")}>Founder view</button> : null}
      </div>
    </>
  );
}
